/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
export type ExtensionVersionResponse = {
	id?: string;
	version: string;
	name: string;
};

export enum ActionTypes {
	SetRequirements = 'setRequirements',
	SetExtension = 'setExtension',
	CheckExtension = 'checkExtension',
	CheckTimedOut = 'checkTimedOut',
	ExtensionUninstalled = 'extensionUninstalled',
	ExtensionUpdated = 'extensionUpdated',
	ResetExtensionCheckStatus = 'resetExtensionCheckStatus',
}

export type ExtensionRequirements = {
	id: string;
	minVersion: string;
	minVersionV2?: string;
	installationUrl: string;
	installationUrlV2?: string;
};
export type SetRequirementsAction = {
	type: ActionTypes.SetRequirements;
	data: {
		requirements: ExtensionRequirements;
		browserName: string;
	};
};

export type SetExtensionAction = {
	type: ActionTypes.SetExtension;
	data: ExtensionVersionResponse & { browserName: string };
};

export type Action =
	| SetRequirementsAction
	| SetExtensionAction
	| { type: ActionTypes.CheckExtension; data: { browserName: string } }
	| { type: ActionTypes.CheckTimedOut }
	| { type: ActionTypes.ExtensionUninstalled }
	| { type: ActionTypes.ResetExtensionCheckStatus }
	| { type: ActionTypes.ExtensionUpdated };

export const setRequirements = (data: SetRequirementsAction['data']): Action => ({
	type: ActionTypes.SetRequirements,
	data,
});

export const checkExtension = (data: { browserName: string }): Action => ({ type: ActionTypes.CheckExtension, data });

export const setExtension = (data: SetExtensionAction['data']): Action => ({ type: ActionTypes.SetExtension, data });

export const checkTimedOut = (): Action => ({ type: ActionTypes.CheckTimedOut });

export const extensionUninstalled = (): Action => ({ type: ActionTypes.ExtensionUninstalled });

export const extensionUpdated = (): Action => ({ type: ActionTypes.ExtensionUpdated });

export const resetExtensionCheckStatus = (): Action => ({ type: ActionTypes.ResetExtensionCheckStatus });
